
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from './firebase';
import { doc, updateDoc } from 'firebase/firestore';

export default function PremiumSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const updateUserStatus = async () => {
      if (auth.currentUser) {
        try {
          // Forza il refresh dei dati utente da Firestore
          const userRef = doc(db, 'users', auth.currentUser.uid);
          const userDoc = await getDoc(userRef);
          
          if (userDoc.exists()) {
            const userData = userDoc.data();
            console.log('✅ Dati utente aggiornati:', userData);
            
            // Verifica che isPremium sia true
            if (userData.isPremium) {
              console.log('✅ Utente Premium verificato!');
              
              // Aggiorna localStorage per forzare refresh nei componenti
              localStorage.setItem('userPremiumStatus', 'true');
              localStorage.setItem('userPremiumUpdated', Date.now().toString());
              
              // Dispatch evento personalizzato per notificare altri componenti
              window.dispatchEvent(new CustomEvent('premiumStatusUpdated', {
                detail: { isPremium: true }
              }));
            }
          }
          
          setTimeout(() => {
            navigate('/');
          }, 3000);
        } catch (error) {
          console.error('Errore nell\'aggiornamento stato utente:', error);
        }
      }
    };

    updateUserStatus();
  }, [navigate]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>✅</div>
        <h1 style={styles.title}>Pagamento Completato!</h1>
        <p style={styles.message}>
          Benvenuto in Wishare Premium! Ora puoi creare wishlist illimitate.
        </p>
        <p style={styles.redirect}>
          Verrai reindirizzato alla home in pochi secondi...
        </p>
        <button 
          style={styles.button}
          onClick={() => navigate('/')}
        >
          Vai alla Home
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    padding: '20px'
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '40px',
    textAlign: 'center',
    maxWidth: '400px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
  },
  icon: {
    fontSize: '48px',
    marginBottom: '20px'
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '16px',
    color: '#333'
  },
  message: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '12px'
  },
  redirect: {
    fontSize: '14px',
    color: '#888',
    marginBottom: '24px'
  },
  button: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 24px',
    fontSize: '16px',
    cursor: 'pointer'
  }
};
